import {
  CompanyDeductionsReportStatus,
  DownloadableDeductionsReportStatuses,
} from 'app/constants/deductionsReports';

/**
 * @description Whether a company deductions report with the given status has been delivered and can be downloaded.
 */
export const isDownloadableDeductionsReportStatus = (
  status?: CompanyDeductionsReportStatus
): boolean => !!status && DownloadableDeductionsReportStatuses.includes(status);

/**
 * @description Whether a company deductions report failed and can be generated again. A failed report the backend marks
 * as not retryable, for example because its company was deleted, cannot. Older responses without the flag are treated
 * as retryable.
 */
export const isRetryableDeductionsReport = (report?: {
  status?: CompanyDeductionsReportStatus;
  retryable?: boolean;
}): boolean => report?.status === 'FAILED' && report.retryable !== false;

/**
 * @description Whether a company deductions report with the given status has recorded problems to show: why it failed,
 * or what it was delivered with warnings about.
 */
export const hasDeductionsReportProblems = (status?: CompanyDeductionsReportStatus): boolean =>
  status === 'FAILED' || status === 'PROCESSED_WITH_WARNINGS';

export default isDownloadableDeductionsReportStatus;
